module.exports = __webpack_public_path__ + "media/images/remove_icon-1e3e6bdfba70df0b3de2ac07793aab67.png";